import { render, staticRenderFns } from "./StandardHeaderLinks.vue?vue&type=template&id=129fadd7&scoped=true"
import script from "./StandardHeaderLinks.vue?vue&type=script&lang=js"
export * from "./StandardHeaderLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129fadd7",
  null
  
)

export default component.exports